export enum Role {
    Entrepreneur,
    Partner,
    Admin,
    RO_Developer
}

export function RoleEnumFromString(value: string): Role {
    const conversion = {
        'entrepreneur': Role.Entrepreneur,
        'partner': Role.Partner,
        'admin': Role.Admin,
        'ro_developer': Role.RO_Developer,
    }

    return conversion[value]
}

export function RoleEnumToString(value: number): string {
    const conversion = ['entrepreneur', 'partner', 'admin', 'ro_developer']
    return conversion[value];
}
